<script lang="ts">
  import { format } from 'date-fns';
  import { nb } from 'date-fns/locale';
  import { i18n } from '../util/i18n/i18n';
  import { trackEvent } from '../util/snowplow';
  import CoreDialog from './core/CoreDialog.svelte';

  export let endTime: string;

  $: closeTime = format(new Date(endTime), "EEEE dd.MM 'kl.' HH:mm", {
    locale: nb,
  });
</script>

<button
  class="tertiary could-not-vote-button"
  data-for="could-not-vote"
  on:click={() => {
    trackEvent({ action: 'click:could-not-vote-open' });
  }}>{i18n('poll.could-not-vote-label')}</button
>
<CoreDialog id="could-not-vote" label={i18n('poll.could-not-vote-label')}>
  <div class="content">
    <!-- svelte-ignore a11y-autofocus -->
    <h2 autofocus tabindex="-1">{i18n('poll.could-not-vote-label')}</h2>
    <p>
      {i18n('poll.could-not-vote')}
    </p>
    <p>
      {i18n('poll.closed', { values: { closeTime } })}
    </p>
    <button class="tertiary close" data-for="close">Lukk</button>
  </div>
</CoreDialog>

<style>
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: var(--spacing-16) auto;
    padding: var(--spacing-16);
    max-width: 28rem;
  }

  h2:focus {
    box-shadow: none;
  }

  p {
    margin-top: 1rem;
  }

  .could-not-vote-button {
    padding: 1rem 4rem;
  }

  .close {
    margin-top: 1rem;
  }
</style>
